import { render, staticRenderFns } from "./PropCollectedUsers.vue?vue&type=template&id=3f538851&"
import script from "./PropCollectedUsers.vue?vue&type=script&lang=js&"
export * from "./PropCollectedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports